var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"dropdown",class:{
        'vue-dropdown': true,
        'is-active': _vm.isActive
    },style:({
        'max-height': _vm.dropdownHeight + 'px'
    })},[_c('transition-group',{attrs:{"name":"item-transition","tag":"ul"}},_vm._l((_vm.items),function(item,index){return _c('li',{key:item.id,class:{
                'vue-dropdown-item': true,
                'is-selected': _vm.selected === index
            },on:{"mouseover":function($event){_vm.selectItem(index)},"click":function($event){_vm.chooseItem(index)}}},[_vm._t("item",[_vm._v("\n                "+_vm._s(item.id)+"\n            ")],{data:item})],2)}))],1)}
var staticRenderFns = []

export { render, staticRenderFns }